export class SupportPlanConst {
  public static readonly LONG_TERM = '長期';
  public static readonly SHORT_TERM = '短期';
}
